import type {
  BusinessSettings,
  PortfolioItem,
  Review,
  ReviewAggregates,
  SalonService,
} from '../types'

const hours = {
  open: '09:00',
  close: '20:00',
  closed: false,
}

export const defaultBusinessSettings: BusinessSettings = {
  businessName: 'Grace Hair Beauty',
  phone: '+13178503001',
  email: 'plbahoure2993@gmail.com',
  address: {
    street: '5401 S East Street Suite 106',
    city: 'Indianapolis',
    state: 'IN',
    zip: '46227',
  },
  hours: {
    monday: hours,
    tuesday: hours,
    wednesday: hours,
    thursday: hours,
    friday: hours,
    saturday: hours,
    sunday: hours,
  },
  socialLinks: {
    instagram: 'https://www.instagram.com/ghbeauty24?igsh=MTM0bGxnMzF1OGI0Zw==',
    facebook: 'https://www.facebook.com/GraceHairBeauty01/',
    tiktok: 'https://www.tiktok.com/@ghbeauty24?_r=1&_t=ZT-96PlSWucAbW',
  },
  googleMapsUrl: 'https://www.google.com/search?kgmid=%2Fg%2F11yytfkdj8&q=Grace+hair+beauty',
  googleReviewUrl: 'https://www.google.com/search?kgmid=%2Fg%2F11yytfkdj8&q=Grace+hair+beauty',
  announcementBanner: null,
  bookingNotice: 'We confirm all appointments within 24 hours.',
}

export const mockServices: SalonService[] = [
  // ── Braids & Protective Styles (african-braids) ─────────────────────
  {
    serviceId: 'svc-miracle-knot',
    name: 'Miracle Knot',
    category: 'african-braids',
    subcategory: 'specialty-braids',
    description: 'A stunning knotted braiding style that blends protection and artistry for a truly unique look.',
    startingPrice: 20000,
    priceUnit: 'cents',
    durationMinutes: 240,
    imageUrl: '/services/miracle-knot-hairstyle.webp',
    featured: true,
    active: true,
    bookingCount: 47,
  },
  {
    serviceId: 'svc-french-curls',
    name: 'French Curls',
    category: 'african-braids',
    subcategory: 'specialty-braids',
    description: 'Romantic curly braids with a soft, textured finish and lasting protective hold.',
    startingPrice: 22000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/boho-knotless-braids-copper.webp',
    imagePosition: 'center 22%',
    featured: true,
    active: true,
    bookingCount: 38,
  },
  {
    serviceId: 'svc-box-braids',
    name: 'Medium Box Braids',
    category: 'african-braids',
    subcategory: 'box-braids',
    description: 'Classic medium box braids with clean square parts, a lightweight feel, and beautiful length.',
    startingPrice: 18000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/box-braids.webp',
    featured: true,
    active: true,
    bookingCount: 163,
  },
  {
    serviceId: 'svc-knotless-braids',
    name: 'Small Knotless Braids',
    category: 'african-braids',
    subcategory: 'knotless-braids',
    description: 'Small knotless braids starting from the root — no knot, no tension, natural lay.',
    startingPrice: 24000,
    priceUnit: 'cents',
    durationMinutes: 360,
    imageUrl: '/services/knotless-braids-wavy-ends.webp',
    imagePosition: 'center 18%',
    featured: true,
    active: true,
    bookingCount: 187,
  },
  {
    serviceId: 'svc-knotless-mid-back',
    name: 'Small Knotless Mid Back',
    category: 'african-braids',
    subcategory: 'knotless-braids',
    description: 'Small knotless braids to mid-back length with a clean, lightweight, tension-free finish.',
    startingPrice: 23000,
    priceUnit: 'cents',
    durationMinutes: 360,
    imageUrl: '/services/knotless-braids-wavy-ends.webp',
    imagePosition: 'center 18%',
    featured: false,
    active: true,
    bookingCount: 74,
  },
  {
    serviceId: 'svc-boho-waist',
    name: 'Jumbo Boho Knotless Butt Length',
    category: 'african-braids',
    subcategory: 'boho-braids',
    description: 'Jumbo boho knotless braids with soft curls and a striking butt-length finish.',
    startingPrice: 18000,
    priceUnit: 'cents',
    durationMinutes: 180,
    imageUrl: '/services/boho-knotless-braids-blonde.webp',
    imagePosition: 'top center',
    featured: true,
    active: true,
    bookingCount: 109,
  },
  {
    serviceId: 'svc-box-braids-styled',
    name: 'Half Box Braids / Half Design Cornrows',
    category: 'african-braids',
    subcategory: 'specialty-braids',
    description: 'Bold half box braids combined with intricate cornrow design work for a statement look.',
    startingPrice: 20000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/box-braids-styled.webp',
    featured: false,
    active: true,
    bookingCount: 43,
  },
  {
    serviceId: 'svc-small-half-half',
    name: 'Small Half / Half',
    category: 'african-braids',
    subcategory: 'specialty-braids',
    description: 'Small braids split with a creative half-braid, half-design combination.',
    startingPrice: 20000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/african-braids.webp',
    featured: false,
    active: true,
    bookingCount: 29,
  },

  // ── Cornrows & Feed-In (african-braids / cornrows-feed-in) ──────────
  {
    serviceId: 'svc-cornrows-straight-back',
    name: 'Cornrows Straight Back',
    category: 'african-braids',
    subcategory: 'cornrows-feed-in',
    description: 'Clean cornrows braided straight back for a classic, protective look with neat edges.',
    startingPrice: 10000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/cornrows-top-bun.webp',
    imagePosition: 'center 18%',
    featured: false,
    active: true,
    bookingCount: 88,
  },
  {
    serviceId: 'svc-feed-in-cornrows',
    name: 'Two Feed-In Cornrows',
    category: 'african-braids',
    subcategory: 'cornrows-feed-in',
    description: 'Two cornrows with a feed-in technique for a sleek, natural flow and smooth finish.',
    startingPrice: 6000,
    priceUnit: 'cents',
    durationMinutes: 90,
    imageUrl: '/services/cornrows-top-bun.webp',
    imagePosition: 'center 18%',
    featured: false,
    active: true,
    bookingCount: 62,
  },

  // ── Wig Cornrows (sew-in / cornrows-feed-in) ────────────────────────
  {
    serviceId: 'svc-wig-cornrows',
    name: 'Wig Cornrows',
    category: 'sew-in',
    subcategory: 'cornrows-feed-in',
    description: 'Flat cornrow base for wig installation with a neat, secure, scalp-friendly finish.',
    startingPrice: 3000,
    priceUnit: 'cents',
    durationMinutes: 45,
    imageUrl: '/services/cornrows-top-bun.webp',
    imagePosition: 'center 18%',
    featured: false,
    active: true,
    bookingCount: 54,
  },

  // ── Twists (african-braids / senegalese-twists, passion-twists, spring-twists) ──
  {
    serviceId: 'svc-senegalese-twist',
    name: 'Senegalese Twists',
    category: 'african-braids',
    subcategory: 'senegalese-twists',
    description: 'Smooth, rope-style Senegalese twists with a clean, lustrous finish and lasting hold.',
    startingPrice: 20000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/senegalese-twist.webp',
    featured: true,
    active: true,
    bookingCount: 91,
  },
  {
    serviceId: 'svc-senegalese-twist-colors',
    name: 'Boho Senegalese Twists',
    category: 'african-braids',
    subcategory: 'senegalese-twists',
    description: 'Senegalese twists with a boho-inspired variation and rich, dimensional texture.',
    startingPrice: 20000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/senegalese-twist-colors.webp',
    featured: false,
    active: true,
    bookingCount: 67,
  },
  {
    serviceId: 'svc-passion-twists',
    name: 'Passion Twists',
    category: 'african-braids',
    subcategory: 'passion-twists',
    description: 'Soft, coily passion twists with a natural, effortless look and lightweight feel.',
    startingPrice: 18000,
    priceUnit: 'cents',
    durationMinutes: 240,
    imageUrl: '/services/crochet-hairstyle.webp',
    featured: false,
    active: true,
    bookingCount: 56,
  },
  {
    serviceId: 'svc-passion-twist-design',
    name: 'Passion Twist Design',
    category: 'african-braids',
    subcategory: 'passion-twists',
    description: 'Passion twists with added creative design detail for a polished, artistic finish.',
    startingPrice: 18000,
    priceUnit: 'cents',
    durationMinutes: 240,
    imageUrl: '/services/crochet-hairstyle.webp',
    featured: false,
    active: true,
    bookingCount: 31,
  },
  {
    serviceId: 'svc-spring-twists',
    name: 'Small Spring Twists',
    category: 'african-braids',
    subcategory: 'spring-twists',
    description: 'Delicate small spring twists with a lightweight, bouncy texture and soft movement.',
    startingPrice: 20000,
    priceUnit: 'cents',
    durationMinutes: 300,
    imageUrl: '/services/senegalese-twist.webp',
    featured: false,
    active: true,
    bookingCount: 44,
  },

  // ── Natural Hair & Ponytails (natural) ──────────────────────────────
  {
    serviceId: 'svc-natural-hairstyle',
    name: 'Two-Strand Twists with Human Hair',
    category: 'natural',
    subcategory: 'natural-styling',
    description: 'Defined two-strand twists blended with human hair for a polished, natural finish.',
    startingPrice: 12000,
    priceUnit: 'cents',
    durationMinutes: 180,
    imageUrl: '/services/natural-hairstyle.webp',
    featured: false,
    active: true,
    bookingCount: 48,
  },
  {
    serviceId: 'svc-ponytail',
    name: 'Medium Ponytail',
    category: 'natural',
    subcategory: 'ponytails',
    description: 'A polished medium ponytail styled for versatility and clean everyday wear.',
    startingPrice: 15000,
    priceUnit: 'cents',
    durationMinutes: 210,
    imageUrl: '/services/natural-hairstyle.webp',
    featured: false,
    active: true,
    bookingCount: 35,
  },

  // ── Men's Styles (men) ──────────────────────────────────────────────
  {
    serviceId: 'svc-men-hairstyles',
    name: 'Men Cornrows',
    category: 'men',
    description: 'Clean cornrows for men with precise parts, neat edges, and a sharp finish.',
    startingPrice: 5000,
    priceUnit: 'cents',
    durationMinutes: 90,
    imageUrl: '/services/man-hairstyle-2.webp',
    imagePosition: 'center 22%',
    featured: true,
    active: true,
    bookingCount: 76,
  },
  {
    serviceId: 'svc-men-box-braids',
    name: 'Men Box Braids',
    category: 'men',
    description: 'Box braids for men with even square parts and a clean, professional appearance.',
    startingPrice: 9000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/man-hairstyle-3.webp',
    imagePosition: 'center 22%',
    featured: false,
    active: true,
    bookingCount: 41,
  },
  {
    serviceId: 'svc-men-twists',
    name: 'Men Medium Two-Strand Twists',
    category: 'men',
    description: 'Medium two-strand twists for men with a natural, low-maintenance style.',
    startingPrice: 8000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/men-hairstyles.webp',
    featured: false,
    active: true,
    bookingCount: 33,
  },
  {
    serviceId: 'svc-men-dreadlocks',
    name: 'Men Loc Retwist & Style',
    category: 'men',
    subcategory: 'locs',
    description: 'Loc retwist with styling for a refined, well-maintained, and polished result.',
    startingPrice: 12000,
    priceUnit: 'cents',
    durationMinutes: 180,
    imageUrl: '/services/men-dreadlocks-hairstyles.webp',
    featured: false,
    active: true,
    bookingCount: 58,
  },
  {
    serviceId: 'svc-loc-barrel-style',
    name: 'Loc Retwist / Barrel Style',
    category: 'men',
    subcategory: 'locs',
    description: 'Loc retwist with a barrel roll style for a clean, defined, and distinguished look.',
    startingPrice: 12000,
    priceUnit: 'cents',
    durationMinutes: 150,
    imageUrl: '/services/men-dreadlocks-hairstyles.webp',
    featured: false,
    active: true,
    bookingCount: 27,
  },
  {
    serviceId: 'svc-loc-retwist',
    name: 'Loc Retwist Only',
    category: 'men',
    subcategory: 'locs',
    description: 'Loc retwist service to keep locs clean, tight, and well-maintained.',
    startingPrice: 8000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/men-dreadlocks-hairstyles.webp',
    featured: false,
    active: true,
    bookingCount: 39,
  },

  // ── Kids & Toddlers (kids) ──────────────────────────────────────────
  {
    serviceId: 'svc-kids-hairstyles',
    name: 'Youth Box Braids',
    category: 'kids',
    subcategory: 'kids-braids',
    description: 'Box braids for youth with gentle technique, clean parts, and a comfortable experience.',
    startingPrice: 15000,
    priceUnit: 'cents',
    durationMinutes: 240,
    imageUrl: '/services/kids-box-braids-star-beads.webp',
    imagePosition: 'top center',
    featured: true,
    active: true,
    bookingCount: 134,
  },
  {
    serviceId: 'svc-kids-mohawk',
    name: 'Kids Mohawk',
    category: 'kids',
    subcategory: 'kids-braids',
    description: 'A clean braided mohawk style for kids with neat edges and confident flair.',
    startingPrice: 8000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/kids-cornrows-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 42,
  },
  {
    serviceId: 'svc-kids-design-mohawk',
    name: 'Kids Design Mohawk',
    category: 'kids',
    subcategory: 'kids-braids',
    description: 'A detailed braided mohawk for kids with creative design patterns and clean lines.',
    startingPrice: 8000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/kids-cornrows-flower-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 28,
  },
  {
    serviceId: 'svc-kids-passion-twists',
    name: 'Kids Passion Twists',
    category: 'kids',
    subcategory: 'kids-twists',
    description: 'Soft, gentle passion twists for kids — age-appropriate and beautifully finished.',
    startingPrice: 9000,
    priceUnit: 'cents',
    durationMinutes: 180,
    imageUrl: '/services/kids-twists-bow.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 51,
  },
  {
    serviceId: 'svc-kids-lemonade-braids',
    name: 'Kids Lemonade Braids',
    category: 'kids',
    subcategory: 'kids-braids',
    description: 'Side-swept lemonade braids for kids with a sleek, stylish, and neat finish.',
    startingPrice: 7000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/kids-cornrows-color-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 36,
  },
  {
    serviceId: 'svc-kids-crochet-cornrows',
    name: 'Kids Half Crochet Cornrows',
    category: 'kids',
    subcategory: 'kids-crochet',
    description: 'Half crochet, half cornrow style for kids with a fun, easy-to-maintain look.',
    startingPrice: 10000,
    priceUnit: 'cents',
    durationMinutes: 150,
    imageUrl: '/services/kids-cornrows-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 23,
  },
  {
    serviceId: 'svc-toddler-box-braids',
    name: 'Toddler Box Braids',
    category: 'kids',
    subcategory: 'toddler-styles',
    description: 'Small box braids for toddlers with an extra gentle, patient, and calm approach.',
    startingPrice: 8000,
    priceUnit: 'cents',
    durationMinutes: 210,
    imageUrl: '/services/kids-box-braids-star-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 47,
  },
  {
    serviceId: 'svc-toddler-ponytail',
    name: 'Toddler Ponytail',
    category: 'kids',
    subcategory: 'toddler-styles',
    description: 'A neat, simple ponytail for toddlers — quick, comfortable, and adorable.',
    startingPrice: 7000,
    priceUnit: 'cents',
    durationMinutes: 120,
    imageUrl: '/services/kids-cornrows-flower-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 31,
  },
  {
    serviceId: 'svc-toddler-two-ponytails',
    name: 'Toddler Two Ponytails',
    category: 'kids',
    subcategory: 'toddler-styles',
    description: 'Two tidy ponytails for toddlers with a sweet, finished, and age-appropriate look.',
    startingPrice: 8000,
    priceUnit: 'cents',
    durationMinutes: 150,
    imageUrl: '/services/kids-cornrows-color-beads.webp',
    imagePosition: 'top center',
    featured: false,
    active: true,
    bookingCount: 29,
  },
]

export const mockPortfolio: PortfolioItem[] = [
  // ── Knotless Braids ───────────────────────────────────────────────────
  {
    styleId: 'style-knotless-waist',
    title: 'Waist-Length Knotless Braids',
    category: 'knotless',
    imageUrl: '/services/knotless-braids-wavy-ends.webp',
    thumbnailUrl: '/services/knotless-braids-wavy-ends.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-01T12:00:00Z',
  },
  {
    styleId: 'style-boho-braids',
    title: 'Boho Braids with Soft Curls',
    category: 'knotless',
    imageUrl: '/services/boho-knotless-braids-blonde.webp',
    thumbnailUrl: '/services/boho-knotless-braids-blonde.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-02T12:00:00Z',
  },
  {
    styleId: 'style-boho-golden',
    title: 'Boho Knotless Braids — Golden',
    category: 'knotless',
    imageUrl: '/services/boho-knotless-braids-golden.webp',
    thumbnailUrl: '/services/boho-knotless-braids-golden.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-05T12:00:00Z',
  },
  {
    styleId: 'style-boho-copper',
    title: 'Boho Knotless Braids — Copper',
    category: 'knotless',
    imageUrl: '/services/boho-knotless-braids-copper.webp',
    thumbnailUrl: '/services/boho-knotless-braids-copper.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-06T12:00:00Z',
  },
  {
    styleId: 'style-african-braids',
    title: 'African Braids',
    category: 'knotless',
    imageUrl: '/services/african-braids.webp',
    thumbnailUrl: '/services/african-braids.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-07T12:00:00Z',
  },
  {
    styleId: 'style-fulani-braids',
    title: 'Fulani Braids',
    category: 'knotless',
    imageUrl: '/services/fulani-braids.webp',
    thumbnailUrl: '/services/fulani-braids.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-08T12:00:00Z',
  },
  {
    styleId: 'style-miracle-knot',
    title: 'Miracle Knot Hairstyle',
    category: 'knotless',
    imageUrl: '/services/miracle-knot-hairstyle.webp',
    thumbnailUrl: '/services/miracle-knot-hairstyle.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-09T12:00:00Z',
  },
  {
    styleId: 'style-crochet',
    title: 'Crochet Braids',
    category: 'knotless',
    imageUrl: '/services/crochet-hairstyle.webp',
    thumbnailUrl: '/services/crochet-hairstyle.webp',
    featured: false,
    active: true,
    createdAt: '2026-05-10T12:00:00Z',
  },

  // ── Box Braids ────────────────────────────────────────────────────────
  {
    styleId: 'style-jumbo-box-braids',
    title: 'Jumbo Box Braids',
    category: 'box-braids',
    imageUrl: '/services/jumbo-box-braids.webp',
    thumbnailUrl: '/services/jumbo-box-braids.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-11T12:00:00Z',
  },
  {
    styleId: 'style-box-braids',
    title: 'Classic Box Braids',
    category: 'box-braids',
    imageUrl: '/services/box-braids.webp',
    thumbnailUrl: '/services/box-braids.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-12T12:00:00Z',
  },
  {
    styleId: 'style-box-braids-styled',
    title: 'Styled Box Braids Updo',
    category: 'box-braids',
    imageUrl: '/services/box-braids-styled.webp',
    thumbnailUrl: '/services/box-braids-styled.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-13T12:00:00Z',
  },

  // ── Senegalese Twists ─────────────────────────────────────────────────
  {
    styleId: 'style-senegalese-twist',
    title: 'Senegalese Twists',
    category: 'senegalese',
    imageUrl: '/services/senegalese-twist.webp',
    thumbnailUrl: '/services/senegalese-twist.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-14T12:00:00Z',
  },
  {
    styleId: 'style-senegalese-twist-colors',
    title: 'Senegalese Twists with Color',
    category: 'senegalese',
    imageUrl: '/services/senegalese-twist-colors.webp',
    thumbnailUrl: '/services/senegalese-twist-colors.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-15T12:00:00Z',
  },

  // ── Sew-In ────────────────────────────────────────────────────────────
  {
    styleId: 'style-sew-in-layered',
    title: 'Layered Sew-In',
    category: 'sew-in',
    imageUrl: '/services/sew-in-curly-waves.webp',
    thumbnailUrl: '/services/sew-in-curly-waves.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-16T12:00:00Z',
  },

  // ── Natural Hair ──────────────────────────────────────────────────────
  {
    styleId: 'style-natural-hairstyle',
    title: 'Natural Hairstyle',
    category: 'natural',
    imageUrl: '/services/natural-hairstyle.webp',
    thumbnailUrl: '/services/natural-hairstyle.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-17T12:00:00Z',
  },
  {
    styleId: 'style-cornrows-bun',
    title: 'Cornrows into Top Bun',
    category: 'natural',
    imageUrl: '/services/cornrows-top-bun.webp',
    thumbnailUrl: '/services/cornrows-top-bun.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-18T12:00:00Z',
  },

  // ── Kids ──────────────────────────────────────────────────────────────
  {
    styleId: 'style-kids-beads',
    title: 'Kids Braids with Beads',
    category: 'kids',
    imageUrl: '/services/kids-cornrows-beads.webp',
    thumbnailUrl: '/services/kids-cornrows-beads.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-19T12:00:00Z',
  },
  {
    styleId: 'style-kids-twists-bow',
    title: 'Kids Twists with Bow',
    category: 'kids',
    imageUrl: '/services/kids-twists-bow.webp',
    thumbnailUrl: '/services/kids-twists-bow.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-20T12:00:00Z',
  },
  {
    styleId: 'style-kids-star-beads',
    title: 'Kids Box Braids with Star Beads',
    category: 'kids',
    imageUrl: '/services/kids-box-braids-star-beads.webp',
    thumbnailUrl: '/services/kids-box-braids-star-beads.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-21T12:00:00Z',
  },
  {
    styleId: 'style-kids-color-beads',
    title: 'Kids Cornrows with Color Beads',
    category: 'kids',
    imageUrl: '/services/kids-cornrows-color-beads.webp',
    thumbnailUrl: '/services/kids-cornrows-color-beads.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-22T12:00:00Z',
  },
  {
    styleId: 'style-kids-flower-beads',
    title: 'Kids Cornrows with Flower Beads',
    category: 'kids',
    imageUrl: '/services/kids-cornrows-flower-beads.webp',
    thumbnailUrl: '/services/kids-cornrows-flower-beads.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-23T12:00:00Z',
  },

  // ── Men ───────────────────────────────────────────────────────────────
  {
    styleId: 'style-men-hairstyles',
    title: 'Men Hairstyles',
    category: 'men',
    imageUrl: '/services/men-hairstyles.webp',
    thumbnailUrl: '/services/men-hairstyles.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-24T12:00:00Z',
  },
  {
    styleId: 'style-men-hairstyle-2',
    title: 'Men Braided Style',
    category: 'men',
    imageUrl: '/services/man-hairstyle-2.webp',
    thumbnailUrl: '/services/man-hairstyle-2.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-25T12:00:00Z',
  },
  {
    styleId: 'style-men-hairstyle-3',
    title: 'Men Protective Style',
    category: 'men',
    imageUrl: '/services/man-hairstyle-3.webp',
    thumbnailUrl: '/services/man-hairstyle-3.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-26T12:00:00Z',
  },
  {
    styleId: 'style-men-dreadlocks',
    title: 'Men Dreadlocks',
    category: 'men',
    imageUrl: '/services/men-dreadlocks-hairstyles.webp',
    thumbnailUrl: '/services/men-dreadlocks-hairstyles.webp',
    featured: true,
    active: true,
    createdAt: '2026-05-27T12:00:00Z',
  },
]

export const mockReviews: Review[] = [
  {
    reviewId: 'review-1',
    clientName: 'Amara T.',
    rating: 5,
    body: 'Ariane did an incredible job on my knotless braids. Clean parts, zero tension on my scalp, and they lasted almost 8 weeks. People stop me everywhere asking where I go. I won\'t be going anywhere else!',
    serviceName: 'Knotless Braids',
    createdAt: '2026-04-22T12:00:00Z',
    source: 'website',
    status: 'approved',
    featured: true,
  },
  {
    reviewId: 'review-2',
    clientName: 'Kezia M.',
    rating: 5,
    body: 'Brought my daughter in for the first time and she absolutely loved it. Ariane was so patient and gentle with her — my daughter kept saying she wanted to come back every week. The beads were gorgeous!',
    serviceName: 'Kids Hairstyles',
    createdAt: '2026-04-10T12:00:00Z',
    source: 'website',
    status: 'approved',
    featured: true,
  },
  {
    reviewId: 'review-3',
    clientName: 'Nadia B.',
    rating: 5,
    body: 'Best boho braids I have ever had, and I have been natural for 10 years. The texture was perfect, the length was flawless, and she really listened to exactly what I wanted. 10 out of 10, no question.',
    serviceName: 'Boho Braid Waist Length',
    createdAt: '2026-03-28T12:00:00Z',
    source: 'website',
    status: 'approved',
    featured: true,
  },
  {
    reviewId: 'review-4',
    clientName: 'Imani R.',
    rating: 5,
    body: 'I had a full sew-in done and I am obsessed with the result. It looks completely natural and lays so flat. My coworkers thought I just cut and colored my hair. The salon is clean, welcoming, and professional.',
    serviceName: 'Sew-In',
    createdAt: '2026-03-15T12:00:00Z',
    source: 'website',
    status: 'approved',
    featured: false,
  },
  {
    reviewId: 'review-5',
    clientName: 'Zora A.',
    rating: 5,
    body: 'My hair has never felt so healthy. Ariane spent real time understanding my hair before touching it. The deep treatment plus protective styling combo was exactly what I needed. Highly recommend.',
    serviceName: 'Protective Styling',
    createdAt: '2026-02-20T12:00:00Z',
    source: 'website',
    status: 'approved',
    featured: false,
  },
  {
    reviewId: 'review-6',
    clientName: 'Fatou D.',
    rating: 5,
    body: 'Came in for African braids and left feeling like royalty. The parts are so clean, the install was painless, and the style held up perfectly through two washes. Grace Hair Beauty is a true gem in Indianapolis.',
    serviceName: 'African Braids',
    createdAt: '2026-02-05T12:00:00Z',
    source: 'website',
    status: 'approved',
    featured: false,
  },
]

export const mockReviewAggregates: ReviewAggregates = {
  averageRating: 5.0,
  totalCount: 6,
}
